const swiper = new Swiper('.image-swiper', {
  loop: true,
  centeredSlides: true,
  slideToClickedSlide: true,
  slidesPerView: 'auto',
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  // breakpoints: {
  //   1920: {
  //     centeredSlides: false,
  //   },
  // },
})

const gemSwiper = new Swiper('.image-swiper-gem', {
  loop: true,
  centeredSlides: true,
  slideToClickedSlide: true,
  slidesPerView: 2.2,
  spaceBetween: 117,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
     // when window width is >= 768px
    768: {
      spaceBetween: 134,
    },
    // when window width is >= 1280px
    1280: {
      spaceBetween: 140,
    },
    // when window width is >= 1920px
    1920: {
      spaceBetween: 117,
    },
  },
})